// NHS Dental Charge Bands — England (April 2025)
// Source: NHS England — update annually each April

export const NHS_CHARGE_BANDS = [
  { band: '1', price: 27.9, desc: 'Exam, scale & polish, X-rays' },
  { band: '2', price: 76.6, desc: 'Fillings, extractions, root canal' },
  { band: '3', price: 332.1, desc: 'Crowns, dentures, bridges' },
  { band: '4', price: 27.9, desc: 'Urgent dental treatment' },
];

export const NHS_BAND_PRICES = {
  '1': 27.9,
  '2': 76.6,
  '3': 332.1,
  '4': 27.9,
};

export const NHS_EXEMPTION_REASONS = [
  { value: 'under_18', label: 'Under 18 years old' },
  { value: 'education', label: 'Under 19 in full-time education' },
  { value: 'pregnant', label: 'Pregnant or had a baby in last 12 months' },
  { value: 'hc2', label: 'HC2 certificate holder' },
  { value: 'universal_credit', label: 'Receiving Universal Credit' },
  { value: 'pension_credit', label: 'Receiving Pension Credit' },
  { value: 'income_support', label: 'Receiving Income Support' },
  { value: 'jsa', label: "Receiving Jobseeker's Allowance" },
  { value: 'hospital', label: 'NHS complex treatment (hospital)' },
];

export function getNHSBandPrice(band) {
  return NHS_BAND_PRICES[band] ?? 0;
}

export function getNHSBandDescription(band) {
  return NHS_CHARGE_BANDS.find((b) => b.band === band)?.desc || '';
}
